/* eslint-disable jsx-a11y/anchor-is-valid,jsx-a11y/anchor-has-content */
import {DialogBoxProps} from "common/DialogBox"
import {useFindPathTrackingByEuiAndDate} from "hooks/queries/path-tracking.query"
import dayjs from "dayjs"
import {Pagination} from "common/Pagination"
import {useRootStore} from "store/useRootStore"
import {observer} from "mobx-react"
import styled from "styled-components"
import ReactDatePicker from "react-datepicker"
import {PathTracking} from "dto/path-tracking/path-tracking"
import {LegacyRef, useCallback, useRef, useState} from "react"
import Draggable from "react-draggable"
import {RealDevice} from "dto/realdevice/devices"
import {CircleTag, SensorStatusTag} from "pages/dashboard/wheelchair/WheelchairListItems"
import {NotificationType, showNotification} from "../../../common/Notification";
import {isValidCoordinate, getCoordinateErrorMessage} from "../../../utils/coordinate-validator";

interface PathTrackingWindowProps extends DialogBoxProps {
}

export const PathTrackingWindow = ({show, close}: PathTrackingWindowProps) => {
    if (!show) return null
    return <PathTrackingWindowBody close={close}/>
}
const PathTrackingWindowBody = observer(({show, close}: PathTrackingWindowProps) => {
    const {
        dashboardStore: {
            selectedDevice,
            pathTrackingStore: {pageSize, page, setPage, setLocation, searchDate, setSearchDate},
            map
        }
    } = useRootStore()
    const [selectedPath, setSelectedPath] = useState<PathTracking>()
    const {data: result} = useFindPathTrackingByEuiAndDate()
    console.log("received event : ", result?.content[result.content.length - 1])
    let list = result?.content || []
    list.sort((a: PathTracking, b: PathTracking) => {
        return b.id - a.id
    })
    const count = result?.totalElements || 0
    const panTo = useCallback((lat: number, lng: number, no: string) => {
        setLocation({lat, lng, no})
        map?.panTo(new kakao.maps.LatLng(lat, lng))
    }, [map, setLocation])

    const selectPath = useCallback((path: PathTracking, no: string) => {
        if (!isValidCoordinate(path)) {
            showNotification(getCoordinateErrorMessage(path), NotificationType.ERROR)
            return
        }
        setSelectedPath(path)
        panTo(path.lat, path.lng, no)
    }, [panTo])

    const divRef = useRef(null)
    return (
        <Draggable handle="#tracking-window">
            <div className="pop-content" style={{width: 700}}>
                <a className="delete-btn" onClick={close}/>
                {/*<div className="mainbody" style={{height: 600}}></div>*/}
                <TopMenu divRef={divRef} device={selectedDevice}/>
                <div className="mainbody" style={{height: 480}}>
                    <div className="main-box">
                        <div className="grid-table2 grid-pop-table">
                            <div>
                                <ReactDatePicker
                                    selected={searchDate}
                                    onChange={(date: Date) => {
                                        setSearchDate(date)
                                    }}
                                    className="input group-input"
                                    placeholderText="시작일"
                                    dateFormat="yyyy년 MM월 dd일"
                                />
                            </div>
                            <ListHeader/>
                            <div style={{height: 300, overflowY: "auto"}}>
                                {list.map((path, idx) => {
                                    const date = dayjs(path.receivedAt).format("YYYY/MM/DD HH:mm:ss")
                                    const no = (((page * pageSize) + 1) + idx).toLocaleString()
                                    const isEmergencyStatus = path.status?.status === "EMERGENCY"
                                    const sensorStatus = path.sensorStatus
                                    return (
                                        <div>
                                            <ListItemBox key={path.id}
                                                         style={{background: selectedPath?.id === path.id ? "#ffe08a" : ""}}
                                                         onClick={() => selectPath(path, no)}>
                                                <div className="item">{no} </div>
                                                <div className="item">
                                                    <time>{date}</time>
                                                </div>
                                                <div className="item is-clickable">
                                                    <span className="tag"> 위도</span> {path.lat}
                                                    <span className="tag ml-3"> 경도</span> {path.lng}
                                                </div>
                                                <div className="item has-text-link">
                                                    <span className="tag has-background-link has-text-white">
                                                        {path.gradient?.x.toLocaleString() || 0}
                                                    </span>
                                                    <span
                                                        className="tag has-background-link has-text-white ml-1">
                                                        {path.gradient?.y.toLocaleString() || 0}
                                                    </span>
                                                </div>
                                                <div className="item has-text-info">
                                                    <span
                                                        className={`tag ${isEmergencyStatus ? "has-background-danger-dark has-text-white" : "has-background-success-dark has-text-white"}`}>
                                                        {isEmergencyStatus ? "발생" : "정상"}
                                                    </span>
                                                </div>
                                            </ListItemBox>
                                            <div className="columns  is-gapless ml5 mb0 is-flex-direction-row">
                                                <div style={{marginLeft: 'auto'}}/>
                                                <SensorStatusTag sensorStatus={sensorStatus}/>
                                                <div className="mr10"/>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                            <Pagination changePage={(page) => {
                                setPage(page - 1)
                            }} page={page + 1} size={pageSize} total={count}/>
                        </div>
                    </div>

                </div>
            </div>
        </Draggable>
    )
})

const TopMenu = ({divRef, device}: { divRef?: LegacyRef<any> | undefined, device: RealDevice | undefined }) => {
    return (
        <div className="topbody has-background-success-dark is-clickable" ref={divRef} id="tracking-window">
            <div className="columns">
                <div className="column" style={{height: 65}}>
                    <div className="mt5">
                        <p className="is-size-3">
                            <span className="icon">
                                <i className="fas fa-map-location"/>
                            </span>
                            <span className="ml-3">{device?.name}</span>
                            <span className="ml-3" style={{fontSize: 15}}>(이동경로 추적 정보)</span>
                        </p>
                        <p className="is-size-2"/>
                    </div>
                </div>
                {/*<div className="column">*/}
                <div style={{position: 'absolute', right: 0, bottom: 0}}>
                    <div className="tabs is-boxed2 is-right">
                        <ul>
                            <li className="is-active">
                                <a><span>상세정보</span></a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

const ListHeader = () => {
    return (
        <ListHeaderBox>
            <div className="item ">순번</div>
            <div className="item">날짜</div>
            <div className="item ">위치</div>
            <div className="item is-flex-wrap-nowrap">기울기(좌우,앞뒤)</div>
            <div className="item">상태</div>
        </ListHeaderBox>
    )
}

const ListHeaderBox = styled.header`
  width: 100%;
  display: grid;
  color: #353536;
  border: 0;
  background: #e9f0f5;
  grid-template-columns: 8% 25% auto 15% 12%;
`

const ListItemBox = styled.div`
  //height: 400px;
  overflow-y: auto;
  vertical-align: middle;
  font-size: 0.9rem;
  text-align: center !important;
  color: #353536;
  display: grid;
  grid-template-columns: 8% 25% auto 15% 12%;
  border-bottom: 1px solid #f2f4f4;

  &:first-child {
    border: 0;
  }

  &:hover {
    background: #00d1b2;
  }
`

const StatusBox = styled.div`
  position: absolute;
  right: 0;
  
`